import { getAttributesFromNode } from '../../../utils/dataObj/getAttributesFromNode';

export const socialHtml = (data, parentNode, node, preview) => {
  return (`
    <mj-social-element${getAttributesFromNode(node, parentNode, preview)}></mj-social-element>
  `)
};
